import React from "react";

export type CDNImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  loading?: "lazy" | "eager";
  priority?: boolean;
};

export function getCDNImageUrl(src: string, width: number, height?: number) {
  let finalSrc = src;

  // Replace Google Storage URL with form-data subdomain if present
  if (finalSrc.startsWith("https://storage.googleapis.com/dcm-form-data/")) {
    finalSrc = finalSrc.replace(
      "https://storage.googleapis.com/dcm-form-data/",
      "https://form-data.dreamcoachmatch.com/",
    );
  }

  let resizeProps = "";
  if (height) {
    resizeProps = `,height=${height},fit=cover,gravity=auto`;
  }

  // Prepend CDN URL
  return `https://dreamcoachmatch.com/cdn-cgi/image/width=${width}${resizeProps}/${finalSrc}`;
}

export const CDNImage = (props: CDNImageProps) => {
  const { src, ...rest } = props;
  const finalSrc = getCDNImageUrl(src, rest.width ?? 384);

  return (
    <img
      src={"development" === process.env.NODE_ENV ? src : finalSrc}
      {...rest}
    />
  );
};
